import { createSlice } from "@reduxjs/toolkit";
import changeDiscountStatusApi from "@custom/rtk-apis/billing/discountNotification/changeDiscountStatus";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const changeDiscountStatusSlice = createSlice({
  name: "changeDiscountStatusSlice",
  initialState,
  reducers: {
    resetDiscountSlice (state:any) {
      state.status = "";
      state.result = null;
      state.msg = "";
      state.loading = false;
      state.error = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(changeDiscountStatusApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(changeDiscountStatusApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload?.status;
        state.result = payload?.result;
        state.msg = payload?.msg;
      })
      .addCase(changeDiscountStatusApi.rejected, (state, { payload }) => {
        state.loading = false;
        state.msg =  payload?.msg || 'An unexpected error occurred.';
      });
  },
});

export default changeDiscountStatusSlice.reducer;
export const { resetDiscountSlice } = changeDiscountStatusSlice.actions;
